@if (documents?.length > 0) {
  <div class="documents__list {{ appService.documentStatusFilter }}">
    <div *ngFor="let document of documents; let i = index" class="document {{ document ? listingService.documentStatusClasses(document).join(' ') : 'loading' }}">
      <a class="document-link" [routerLink]="document ? ['/documentos/', document.id] : []">
        <i class="document-icon fa-regular fa-file-alt"></i>
        <p class="document-title">{{ document?.name }}&nbsp;</p>
        <p class="document-date" title="{{ document?.created_at | ldate: 'long' }}">{{ document?.created_at | dateTime: 'mediumDate' }}&nbsp;</p>
        <div class="document-status">
          <span *ngIf="document && documentService.isSigned(document) && !documentService.isExpired(document)">
            {{
              document.expiration_at
                ? ((document.is_dynamic_document ? 'documents.filledAndSignedExpiresIn' : 'documents.signedExpiresIn') | translate: { expiration: document.expiration_at | ldate: 'mediumDate' })
                : ((document.is_dynamic_document ? 'documents.filledAndSigned' : 'documents.signed') | translate)
            }}
          </span>
          <span *ngIf="!document || (documentService.isPending(document) && !documentService.isExpired(document))" style="font-weight: 400">
            <span
              *ngIf="document"
              [innerHTML]="
                'documents.pending'
                  | translate
                    : {
                        pendingSigners: ({ signers: document.signatures } | filterPendingSigners).length,
                        totalSigners: ({ signers: document.signatures } | filterSigners).length
                      }
              "
            ></span
            >&nbsp;
          </span>
          <span *ngIf="document && documentService.isExpired(document)">
            {{ 'documents.expiredIn' | translate: { expiration: document.expiration_at | ldate: 'mediumDate' } }}
          </span>
          <span *ngIf="document && documentService.isRejected(document)">{{ 'documents.rejected' | translate }}</span>
          <span *ngIf="document && documentService.isWarning(document)">{{ 'documents.warning' | translate }}</span>
        </div>
        <div class="document-subscribers">
          <ng-container *ngFor="let signer of document ? ({ signers: document.signatures } | filterSigners | slice: 0 : getMaxSigners(document)) : [].constructor(3)">
            <p
              *ngIf="!signer || returnSignerIdentifier(signer)"
              class="document-subscriber"
              [ngClass]="{
                checked: documentService.isSignerSigned(signer) && signer?.action,
                canceled: documentService.isSignerRejected(signer),
                unapproved: documentService.isSignerUnapproved(signer),
                warning: documentService.isSignerError(signer)
              }"
            >
              {{ signer ? returnSignerIdentifier(signer) : '' }}&nbsp;
            </p>
          </ng-container>
          <p class="document-more" *ngIf="document && ({ signers: document.signatures } | filterSigners).length > maxSigners">
            {{ 'documents.additionalSigners' | translate: { signers: ({ signers: document.signatures } | filterSigners).length - getMaxSigners(document) } }}
          </p>
        </div>
        <ng-container *ngIf="document">
          <div class="document-bottom-block deadline" *ngIf="documentService.isPastDeadline(document); else bottomDeleted" [ngbTooltip]="tipPastDeadline" placement="right">
            <div><i class="far fa-lock"></i>&nbsp;<span [innerHTML]="'documents.blocked' | translate"></span></div>
          </div>
          <ng-template #bottomDeleted>
            <div
              class="document-bottom-block deleted"
              *ngIf="currentOrganizationMemberId && listingService.deletedByUserAt(document, currentOrganizationMemberId); else bottomLifecycle"
              [ngbTooltip]="tipDeletedByUserAt"
              placement="right"
            >
              {{ 'documents.deleted' | translate }}
            </div>
          </ng-template>
          <ng-template #bottomLifecycle>
            <div class="document-bottom-block lifecycle" *ngIf="documentService.isPastLifecycle(document); else bottomSandbox" [ngbTooltip]="tipPastLifecycle" placement="right">
              <div>
                <i class="far fa-boxes-alt"></i>&nbsp; <strong>{{ 'documents.lifecycleExpired' | translate }}</strong>
              </div>
            </div>
          </ng-template>
          <ng-template #bottomSandbox>
            <div class="document-bottom-block sandbox" *ngIf="document?.sandbox" [ngbTooltip]="tipDocumentSandbox" placement="right">{{ 'documents.sandboxDocument' | translate }}</div>
          </ng-template>
        </ng-container>

        <ng-template #tipPastDeadline>
          <div class="tooltip__title">{{ 'documents.documentBlocked' | translate }}</div>
          <div class="tooltip__descr">{{ 'documents.documentBlockedDate' | translate: { date: document?.deadline_at | dateTime } }}</div>
        </ng-template>

        <ng-template #tipDeletedByUserAt>
          <div class="tooltip__title">{{ 'documents.deletedDocument' | translate }}</div>
          <div class="tooltip__descr">
            {{ 'documents.deletedDocumentMessage' | translate: { date: listingService.deletedByUserAt(document, currentOrganizationMemberId) | ldate } }}
          </div>
        </ng-template>

        <ng-template #tipPastLifecycle>
          <div class="tooltip__title">{{ 'documents.lifecycleExpired' | translate }}</div>
          <div class="tooltip__descr">{{ 'documents.lifecycleExpiredMessage' | translate: { date: document.lifecycle_in | ldate } }}</div>
        </ng-template>

        <ng-template #tipDocumentSandbox>
          <div class="tooltip__title">{{ 'documents.sandboxDocument' | translate }}</div>
          <div class="tooltip__descr">{{ 'documents.sandboxDocumentDescr' | translate }}</div>
        </ng-template>
      </a>
      @if (document && !isTrash && !documentsListingService.deletedByUserAt(document, currentUser?.id)) {
        <div appDropdown placement="bottom-right" class="document-dropdown">
          <button type="button" class="dropdown__toggle-control dropdown__toggle-control--corner dropdown__toggle-control--icon-only" appDropdownToggle>
            <i class="far fa-ellipsis-v dropdown__toggle-icon--font-size-16"></i>
          </button>

          <div appDropdownMenu>
            @if (listingService.isAllowedToSign(document) && !document.is_dynamic_document) {
              <button type="button" appDropdownItem (click)="signClick.emit([document])"><i class="fa-regular fa-feather-alt"></i> {{ 'button.sign' | translate }}</button>
            }

            <button
              type="button"
              appDropdownItem
              [submenuToggle]="'box-submenu1-' + document.id"
              [attr.aria-labelledby]="'box-submenu1-' + document.id"
              [disabled]="documentService.isPastLifecycle(document)"
            >
              <i class="fa-regular fa-cloud-download-alt"></i> {{ 'button.download' | translate }}
            </button>

            @if (listingService.isAllowedToArchive(document) && urlParamsService.params.archiveDocument) {
              <button type="button" appDropdownItem (click)="folderClick.emit([document])"><i class="fa-regular fa-archive"></i> {{ 'button.archive' | translate }}</button>
            }

            @if (listingService.isAllowedToManage(document) && !appService.isEnterpriseChild) {
              <button type="button" appDropdownItem (click)="transferClick.emit([document])"><i class="fa-regular fa-file-export"></i> {{ 'button.transfer' | translate }}</button>
            }

            @if (listingService.isAllowedToToggleBlock(document)) {
              <button type="button" appDropdownItem (click)="toggleBlockClick.emit([document])">
                <i class="fa-regular fa-{{ documentService.isPastDeadline(document) ? 'lock-open' : 'lock' }}"></i>
                {{ 'button.' + (documentService.isPastDeadline(document) ? 'unblock' : 'block') | translate }}
              </button>
            }

            @if (listingService.isAllowedToDelete(document)) {
              <hr class="dropdown-divider" />
              <button type="button" class="dropdown__item--danger" appDropdownItem (click)="deleteClick.emit([document])">
                <i class="fa-regular fa-trash"></i> {{ 'button.exclude' | translate }}
              </button>
            }

            @if (listingService.isAllowedToResendWebhook(currentUser, document)) {
              <button type="button" appDropdownItem (click)="resendWebhookClick.emit(document)"><i class="fa-regular fa-webhook"></i> {{ 'button.webhookResend' | translate }}</button>
            }
          </div>

          <div [id]="'box-submenu1-' + document.id" [appDropdownSubmenu]="'box-submenu1-' + document.id">
            <button type="button" appDropdownBackButton>{{ 'button.back' | translate }}</button>

            <a [href]="documentService.signedDocumentUrl(document)" appDropdownItem [disabled]="!documentService.isSignedOnce(document)" target="_blank">
              <i [class]="document.qualified || hasMixedSignature(document) ? 'fa-regular fa-print' : 'fa-regular fa-file-contract'"></i>
              {{ (document.qualified || hasMixedSignature(document) ? 'documents.printPDF' : 'documents.signedPDF') | translate }}
            </a>

            @if (!document.qualified) {
              <a appDropdownItem [href]="document.files?.certified" [disabled]="!documentService.isSignedOnce(document)" target="_blank">
                <i class="fa-regular fa-file-certificate"></i> {{ 'documents.sealedPDF' | translate }}
              </a>
            }

            @if (document.qualified || hasMixedSignature(document)) {
              <a appDropdownItem [href]="documentService.padesDocumentUrl(document)" [disabled]="!documentService.isSignedOnce(document)" target="_blank">
                <i class="fa-regular fa-file-code"></i> {{ 'documents.padesFile' | translate }}
              </a>
            }

            <a href="javascript:void(0)" appDropdownItem (click)="documentService.downloadFile(document)" [disabled]="!document.files?.original">
              <i class="fa-regular fa-file-alt"></i> {{ 'documents.originalFile' | translate }}
            </a>
          </div>
        </div>
      }
      @if (document && listingService.isAllowedToDelete(document) && (isTrash || documentsListingService.deletedByUserAt(document, currentUser?.id))) {
        <div class="document-dropdown" appDropdown placement="bottom-right" container="body">
          <label appDropdownToggle><i class="fa-regular fa-ellipsis-v"></i></label>
          <div appDropdownMenu>
            <button type="button" (click)="restoreClick.emit([document])" appDropdownItem><i class="fa-regular fa-undo"></i> {{ 'button.restore' | translate }}</button>
          </div>
        </div>
      }
    </div>
  </div>

  @if (currentUser && !hidePagination && !isLoading) {
    <button type="button" class="btn-M btn-text icon-start" (click)="loadPageClick.emit()">
      <i class="fas fa-rotate-reverse"></i>
      {{ 'button.loadMore' | translate }}
    </button>
  }
}
